export default __webpack_public_path__ + "static/media/wordpress.f7961c09.svg";